import privilegeService from '@/services/privilege.service'

export const AUTOMATION_LISTS = {
  drop: '/automation/drops',
  workflow: '/automation/workflows',
  message: '/automation/scheduled-messages'
}

const AUTOMATION_AREAS = [
  { name: 'Drops', link: AUTOMATION_LISTS.drop, match: [AUTOMATION_LISTS.drop, '/automation/drop'] },
  { name: 'Workflows', link: AUTOMATION_LISTS.workflow, match: [AUTOMATION_LISTS.workflow, '/automation/workflow'] },
  {
    name: 'Scheduled messages',
    link: AUTOMATION_LISTS.message,
    match: [AUTOMATION_LISTS.message, '/automation/message']
  },
  { name: 'Sent messages', link: '/automation/sent-messages', match: ['/automation/sent-messages'] }
]

export default {
  bases: ['/automation'],
  fetches: [],
  build: () => (privilegeService.canAccessResourceAction('automation', null, 'read') ? AUTOMATION_AREAS : [])
}
